import { getTestimonials } from './get-testimonials';

/**
 * Trustpilot reviews are withheld below `REVIEW_MINIMUM_THRESHOLD`, where a handful of them would
 * misrepresent the program. Graduate testimonials are curated per program and stand on their own,
 * so the section still earns its place (and its section divider) without any reviews.
 */
export function shouldRenderReviewsSection({
  hasTrustpilotReviews,
  programKey,
}: {
  hasTrustpilotReviews: boolean;
  programKey: string;
}) {
  return hasTrustpilotReviews || Boolean(getTestimonials(programKey)?.length);
}
